import { RegisterOrUpdateDynamicObjectsWithValuesPayload } from 'views/TenantProfileSettings/components/types';

/**
 * Generates a payload object of type RegisterOrUpdateDynamicObjectsWithValuesPayload.
 *
 * @param {number} objectDefinitionId - The ID of the object definition.
 * @param {number} id - The ID of the object instance.
 * @param {Record<string, any>} objectValues - An object mapping property IDs to their values.
 * @returns {RegisterOrUpdateDynamicObjectsWithValuesPayload} The payload to be used for registering or updating a dynamic object.
 */
export const generateBusinessObjectToAtribute = (objectDefinitionId: number, objectValues: Record<string, any>, id?: number) => {
    const values = Object.entries(objectValues).map(([key, value]) => ({ propertyId: +key, value }));

    const obj: RegisterOrUpdateDynamicObjectsWithValuesPayload = {
        data: { objectDefinitionId, id, values }
    };

    return obj;
};

export const objectNameToFieldNameMapping = {
    'Remit To': 'remitTo',
    Address: 'address',
    'AR Contact': 'arContact',
    'AP Contact': 'apContact'
};
export const contactsObjectToFieldMapping = { 'AR Contact': 'arContact', 'AP Contact': 'apContact' };
export type ContactsObjectToFieldMappingType = typeof contactsObjectToFieldMapping;
